module.exports = __webpack_public_path__ + "static/25-c7abc92d4b5d4238c6d0bf7166e0aa26.jpg";